import { UserCredentialsLogin } from '@auth/models/user-credentials-login.interface';
import { createAction, props } from '@ngrx/store';

import { IUser } from '@shared/interfaces/user.interface';

export const LOGIN_REQUEST = createAction(
  '[LOGIN] Inicio proceso de login',
  props<{ userCredentialsLogin: UserCredentialsLogin }>(),
);

export const LOGIN_SUCCESS = createAction('[LOGIN] Inicio de Sesion Exitoso', props<{ user: IUser; token: string }>());

export const LOGIN_FAILED = createAction('[LOGIN]  Inicio de Sesion Fallido');

export const LOGOUT_SUCCESS = createAction('[LOGIN] Sesion Cerrada');

export const LOGOUT_FAILED = createAction('[LOGIN] Sesion No Cerrada');

export const LOGIN_REQUEST_FAILED = createAction('[LOGIN] Error Inicio de Sesion', props<{ payload: any }>());
